export default __webpack_public_path__ + "static/media/faq_quote.465d72b5.svg";